/* eslint-disable */
import React, { useContext, useState } from 'react';

import {
  IconButton,
  InputAdornment,
  Grid,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';

import { useValidPassword } from '../../hooks/useValidPassword';
import { useValidEmail } from '../../hooks/useValidEmail';
import {
  inputStyle,
  labelStyle,
  logoStyle,
  paperStyle,
  pLabelDarkerStyle,
  pLabelStyle,
} from '../styles';
import { AuthContext } from '../../contexts/authContext';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { PasswordType } from '../../interfaces/IPassType';
import { forgotLabelStyle, signInTypographyStyle } from './styles';
import { PAGES } from '../../../../types/pages';
import { AuthPAGES } from '../../constants/pages';
import { MuiButton } from '../../components/Button/Button';
import { Notif } from '../../components/Snackbar/Snackbar';
import { Header } from '../../components/Header/Header';
import { useValidCode } from '../../hooks/useValidCode';
import ReactCodeInput from 'react-code-input';
import './SignIn.scss';
import { useCountDown } from '../../hooks/useCountDown';

const SignIn: React.FC<any> = () => {
  const { email, setEmail, emailIsValid } = useValidEmail(null);
  const { password, setPassword } = useValidPassword('');
  const [showPassword, setshowPassword] = useState<boolean>(false);
  const [inProgress, setInProgress] = useState<boolean>(false);
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [genericErrorMessage, setGenericErrorMessage] = useState('');
  const [open, setOpen] = React.useState(false);
  const [rememberMe, setRememberMe] = React.useState(false);
  const [step, setStep] = React.useState<'signIn' | '2fa'>('signIn');
  const { code, setCode } = useValidCode('');
  const [sending, setSending] = useState<boolean>(false);
  const { seconds, setSeconds, setIsActive } = useCountDown(30);

  const handleClickShowPassword = () => {
    setshowPassword(!showPassword);
  };

  const sendCode = async (e: any) => {
    e.stopPropagation();
    setSending(true);
    try {
      await authContext.respondToCustomChallenge(email, code);
      setSending(false);
    } catch (err: any) {
      setSending(false);
      setGenericErrorMessage(
        `Incorrect activation code entered, please try again`
      );
      setOpen(true);
      setStep('signIn');
      setGenericErrorMessage(
        `Incorrect activation code entered, please try again`
      );
    }
  };

  const signInCallback = () => {
    if (email) setStep('2fa');
    setInProgress(false);
  };

  const onLoginPressed = async (e: any) => {
    e.stopPropagation();
    setInProgress(true);
    if (email && password)
      try {
        await authContext.signInWithEmail(email, password, signInCallback);
        setInProgress(false);
        if (!authContext.isMultifactor) {
          if (rememberMe) authContext.rememberDevice();
          navigate(PAGES.home);
        }
      } catch (error: any) {
        if (error.code === 'NEW_PASSWORD_REQUIRED') {
          try {
            navigate(
              `${AuthPAGES.checkPassword}/${email}/${PasswordType.SIGNUP}/${password}`
            );
          } catch (err: any) {
            setGenericErrorMessage(`${err.message}`);
            setOpen(true);
            setInProgress(false);
          }
        } else if (error.code === 'UserNotConfirmedException') {
          try {
            authContext.setEmail(email);
            await authContext.reSendCode(email);
            navigate(AuthPAGES.verifyEmail);
          } catch (err: any) {
            setGenericErrorMessage(`${err.message}`);
            setOpen(true);
            setInProgress(false);
          }
        } else {
          setGenericErrorMessage(`${error.message}`);
          setOpen(true);
          setInProgress(false);
        }
      }
  };

  const isButtonDisabled = () => {
    return emailIsValid !== '' || password === '' || inProgress;
  };

  const isCodeButtonDisabled = () => {
    return code?.length !== 6 || sending;
  };

  const onKeyUp = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.code === 'Enter') {
      onLoginPressed(event);
    }
  };

  return (
    <Grid container justifyContent='center' alignContent='center'>
      <Grid item xl={4} lg={4} md={6} sm={10} xs={11}>
        <Paper
          elevation={0}
          style={paperStyle}
          className='responsive-paper-style'
        >
          {step === 'signIn' && (
            <>
              <Grid item xs={12} md={12} xl={12} style={logoStyle}>
                <Header text1='Sign In' text2='Sign In to your account' />
              </Grid>
              <Grid item xs={12} md={12} xl={12}>
                <TextField
                  id='outlined-adornment-email'
                  label='E-mail'
                  variant='outlined'
                  error={genericErrorMessage !== '' || emailIsValid !== ''}
                  helperText={emailIsValid !== '' ? 'Check your email' : ''}
                  style={{
                    ...inputStyle,
                    marginBottom: emailIsValid !== '' ? '15px' : '',
                  }}
                  fullWidth
                  size='small'
                  value={email ?? ''}
                  onChange={(e: any) => setEmail(e.target.value)}
                  InputProps={{
                    style: {
                      borderRadius: '50px',
                      color: genericErrorMessage !== '' ? 'red' : '',
                    },
                    startAdornment: (
                      <InputAdornment position='start'>
                        <EmailOutlinedIcon
                          style={{
                            color:
                              genericErrorMessage !== '' ? 'red' : '#227BEF',
                            width: '20px',
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} xl={12}>
                <TextField
                  label='Password'
                  variant='outlined'
                  error={genericErrorMessage !== ''}
                  size='small'
                  fullWidth
                  style={inputStyle}
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onKeyUp={onKeyUp}
                  onChange={(e: any) => setPassword(e.target.value)}
                  InputProps={{
                    style: {
                      borderRadius: '50px',
                      color: genericErrorMessage !== '' ? 'red' : '',
                    },
                    startAdornment: (
                      <InputAdornment position='start'>
                        <LockOutlinedIcon
                          style={{
                            color:
                              genericErrorMessage !== '' ? 'red' : '#227BEF',
                            width: '20px',
                          }}
                        />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position='end'>
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge='end'
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={12} xl={12} style={{ marginTop: '32px' }}>
                <MuiButton
                  loading={inProgress}
                  disabled={isButtonDisabled()}
                  text='Sign In'
                  onSubmit={onLoginPressed}
                />
              </Grid>
              <Grid item xs={12} md={12} xl={12} style={forgotLabelStyle}>
                <Typography style={signInTypographyStyle}>
                  <Link
                    to={AuthPAGES.forgotPassword}
                    style={{ ...pLabelStyle, margin: 0 }}
                  >
                    Forgot your password?
                  </Link>
                </Typography>
              </Grid>
              {!window.location.host.includes('admin') && (
                <Grid item xs={12} md={12} xl={12} style={labelStyle}>
                  <Typography style={pLabelDarkerStyle}>
                    Don't have an account?
                    <br />
                    <Link to={AuthPAGES.signUp} style={pLabelStyle}>
                      Sign Up
                    </Link>
                  </Typography>
                </Grid>
              )}
            </>
          )}
          {step === '2fa' && (
            <>
              <Grid item xs={12} md={12} xl={12} style={logoStyle}>
                <div>
                  <h2 className='tfa-title'>Verify</h2>
                  <p className='tfa-subtitle'>{`We've sent an activation code to your email ${email}`}</p>
                </div>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'space-evenly' }}
              >
                <ReactCodeInput
                  type='text'
                  fields={6}
                  name='anyName'
                  inputMode='tel'
                  className='code-input'
                  onChange={(e: any) => setCode(e)}
                />
              </Grid>
              <Grid item xs={12} style={labelStyle}>
                <Typography style={{ marginBottom: '10px' }}>
                  <Link
                    to=''
                    className='resend-code'
                    onClick={(e) => {
                      if (seconds > 0) return;
                      setSeconds(30);
                      setIsActive(true);
                      onLoginPressed(e);
                    }}
                    style={pLabelDarkerStyle}
                  >
                    {seconds > 0
                      ? `Resend your code if it does not arrive in ${seconds}`
                      : sending
                      ? 'sending...'
                      : 'Send Code Again'}
                  </Link>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <MuiButton
                  loading={sending}
                  disabled={isCodeButtonDisabled()}
                  text='Confirm'
                  onSubmit={sendCode}
                />
              </Grid>
            </>
          )}
        </Paper>
      </Grid>
      <Notif open={open} setOpen={setOpen} message={genericErrorMessage} />
    </Grid>
  );
};

export default SignIn;
